<template>
  <div>
    <v-container style="width: 100%; max-width: 100%;padding: 12px;">
      <div class="row">
        <div class="col-md-8 col-sm-12 col-xs-12 pa-1 px-1">
          <v-breadcrumbs class="pb-0" :items="breadcrums()">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item color="primary" class="text--primary" :href="item.href" :disabled="item.disabled">
                {{ item.text }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
          <v-carousel :height="(mount_height+20)+`px`" :reverse="AppRtl" hide-delimiters hide-delimiter-background show-arrows>
            <template v-slot:next="{ on, attrs }">
              <app-dt-btn max-height="30" min-heigt="27" min-width="27" @click="clickNext(SelectedAttchment.ind)">
                <v-icon v-if="AppRtl">mdi-chevron-left</v-icon>
                <v-icon v-if="!AppRtl">mdi-chevron-right</v-icon>
              </app-dt-btn>
            </template>
            <template v-slot:prev="{ on, attrs }">
              <app-dt-btn max-height="30" min-heigt="27" min-width="27"
                  @click="clickPrev(SelectedAttchment.ind)">
                <v-icon v-if="AppRtl">mdi-chevron-right</v-icon>
                <v-icon v-if="!AppRtl">mdi-chevron-left</v-icon>
              </app-dt-btn>
            </template>
            <v-carousel-item class="mx-0 mb-0 pb-0">
              <app-row class="pa-0 ma-0" align="center" justify="center">
                <v-img style="cursor: pointer;" @click="ContentShowDialogActivator" v-if="Number(SelectedAttchment.file_type)===1" :max-height="mount_height3+`px`" :height="mount_height3+`px`" contain :lazy-src="SelectedAttchment.med_url" :src="SelectedAttchment.med_url" alt="" />
                <video :max-height="(mount_height+20)+`px`" :height="(mount_height+20)+`px`" v-if="SelectedAttchment.file_type===2" :id="`video`+SelectedAttchment.id" :ref="`video`+SelectedAttchment.id" controls controlsList="nodownload" width="100%" progress crossorigin playsinline>
                  <source :src="SelectedAttchment.url" :type="SelectedAttchment.mime_type"/>
                </video>
                <iframe width="100%" :height="(mount_height+20)+`px`" v-if="SelectedAttchment.file_type===3" :src="`https://www.youtube.com/embed/`+SelectedAttchment.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </app-row>
            </v-carousel-item>
          </v-carousel>
          <v-slide-group active-class="noop" :prev-icon="AppRtl?`mdi-chevron-left`:`mdi-chevron-right`" :next-icon="AppRtl?`mdi-chevron-right`:`mdi-chevron-left`" class="mt-0 pt-0" v-model="slideValue" style="background: lightgrey !important;color: black; !important;" show-arrows>
            <v-slide-item v-slot="{ active, toggle }" v-for="(attachment, b) in product.attachments" :key="'att'+b" style="background: lightgrey !important;color: black; !important;">
              <v-card height="60" width="60" @click="onCardClick(b)" class="pt-1">
                <v-img :lazy-src="attachment.thumb_url" :src="attachment.thumb_url" :aspect-ratio="1" max-height="58px !important;" height="58px !important;" max-width="58px !important;" width="58px !important;" style="border-radius: 10px 10px 10px 10px !important;" class="pointer mx-1 my-0 nooponhover" alt="" @click="showAttachment(attachment,b)">
                  <v-icon v-if="attachment.file_type===2||attachment.file_type===3" @click="showAttachment(attachment)" color="primary" size="60" class="pointer">mdi-youtube</v-icon>
                </v-img>
              </v-card>
            </v-slide-item>
          </v-slide-group>
          <v-card-actions class="pa-0 ma-0" style="width:100%;">
            <v-btn width="100%" v-if="isLogin&&user.mobile_verification&&user.verfied_user_identities_counter>0&&product.product_status===1&&product.show_sale===false" min-width="100%" md="6" sm="12" class="error white--text" outlined tile dense><v-icon>mdi-cart</v-icon> {{$t('car_order1')}} {{product.show_at_to_string}}</v-btn>
            <v-btn width="100%" v-if="isLogin&&user.mobile_verification&&user.verfied_user_identities_counter>0&&product.product_status===1&&product.show_sale===true" min-width="100%" md="6" sm="12" class="primary white--text" @click="AddProductDialogActivator" outlined tile dense><v-icon>mdi-cart</v-icon> {{$t('car_order')}}</v-btn>
            <v-btn width="100%" v-if="isLogin&&(!user.mobile_verification||user.verfied_user_identities_counter<1)&&product.product_status===1" min-width="100%" md="6" sm="12" class="error white--text" outlined tile dense><v-icon>mdi-account-lock</v-icon> {{$t('cant_order')}}</v-btn>
            <v-btn width="100%" v-if="isLogin&&product.product_status!==1" min-width="100%" md="6" sm="12" class="error white--text" outlined tile dense><v-icon>mdi-account-clock</v-icon> {{product.product_status_to_string}}</v-btn>
            <v-btn width="100%" v-if="!isLogin" min-width="100%" md="6" sm="12" class="primary white--text" @click="LoginModalActivatior" outlined tile dense><v-icon>mdi-lock-open</v-icon> {{$t('login')}}</v-btn>
          </v-card-actions>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12 pa-2 px-1 pt-2">
          <v-row id="ProductDataRow" ref="ProductDataRow" class="pa-0 ma-0">
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('car_manufacture')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.manufacturer_id_to_string}}
              </v-card-text>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('car_name')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.name_to_string}} / SKU {{product.product_sku}}
              </v-card-text>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('car_year')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.product_year_id_to_string}}
              </v-card-text>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('car_km')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.km_to_number_format}} {{parseAttribute('km')}}
              </v-card-text>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('car_chassie')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.chassie}}
              </v-card-text>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('car_out_color')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.product_out_color_id_to_string}}
              </v-card-text>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('car_in_color')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.product_in_color_id_to_string}}
              </v-card-text>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('car_fuel_type')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.fuel_type_id_to_string}}
              </v-card-text>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('price')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.price_to_number_format}}
              </v-card-text>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('brokerage_with_vat')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.brokerage_services_with_vat_to_number_format}}
              </v-card-text>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('total2')}}:
              </v-card-text>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 pa-0 ma-0 text-center" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 ps-3 py-1 details-data">
                {{product.product_final_total_to_number_format}}
                <v-btn class="app-btn align-self-baseline" icon @click="InfoModalActivatior">
                  <app-tooltip :text="parseAttribute('Info_info_click')">
                    <v-icon color="primary" large> mdi-information-outline</v-icon>
                  </app-tooltip>
                </v-btn>
              </v-card-text>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12 pa-0 ma-0" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{parseAttribute('body_check')}}:
              </v-card-text>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12 pa-0 ma-0 ps-1" style="margin-bottom: 2px !important;border-style: solid;border-width: 0px 0px 1px 0px;">
              <v-card-text class="pa-0 ma-0 py-1 details-data pt-1 ps-1">
                  {{product.body_check}}
              </v-card-text>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12 pa-0 ma-0">
              <v-card-text class="pa-0 ma-0 details-label ps-3 py-1">
                {{$t('description')}}:
              </v-card-text>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12 pa-0 ma-0 ps-1">
              <v-card-text class="pa-0 ma-0 py-1 details-data pt-1 ps-1" style="margin-bottom: 2px !important;">
                {{product.notes}}
              </v-card-text>
            </div>
            <v-card-actions class="pa-0 ma-0" style="width: 100%;">
              <v-btn width="100%" @click="subscribe" :loading="subscribeLoading" v-if="isLogin&&!subscribe_status" max-width="100%" md="12" sm="12" class="primary white--text" outlined tile dense><v-icon class="align-self-start">mdi-playlist-check</v-icon>{{$t('product_subscription')}}</v-btn>
              <v-btn width="100%" @click="unsubscribe" :loading="unsubscribeLoading" v-if="isLogin&&subscribe_status" max-width="100%" md="12" sm="12" class="error white--text" outlined tile dense><v-icon class="align-self-start">mdi-playlist-check</v-icon>{{$t('product_no_subscription')}}</v-btn>
            </v-card-actions>
          </v-row>
        </div>
      </div>
      <div class="row mt-1">
        <div v-if="visiblePages&&visiblePages.length&&visiblePages.length>0" class="col-sm-12 col-xs-12 col-md-12 pa-1">
          <v-card-text class="pa-0 pt-4" tile outlined>
            <p class="subtitle-1 font-weight-light pt-3 text-center">{{$t('you_might_also_like')}}</p>
            <v-divider></v-divider>
            <div class="row text-center">
              <div class="col-md-3 col-sm-6 col-xs-12" :key="`like`+pro.id" v-for="pro in visiblePages">
<!--                <v-hover v-slot:default="{ hover }">-->
                  <v-card @click="Selectedproduct(pro.id)" class="mx-auto " color="grey lighten-4" max-width="600">
                    <v-img class="white--text align-end" :aspect-ratio="16/9" height="200px" :lazy-src="(pro.attachments&&pro.attachments[0]&&pro.attachments[0].med_url)?pro.attachments[0].med_url:''" :src="(pro.attachments&&pro.attachments[0]&&pro.attachments[0].med_url)?pro.attachments[0].med_url:''">
                      <v-btn v-if="pro.product_status===1" class="mygreen font-weight-bold px-1 py-1" style="position:absolute !important; line-height: 1.5;top:0;right: 0;left: 0;padding-top: 0;height:20px;font-size: 14px;border-radius: 15px 0;color: #ffffffb3;background: rgb(42 54 134);">
                        {{pro.product_status_to_string}}
                      </v-btn>
                      <v-btn v-if="pro.product_status===2" class="myorange font-weight-bold px-1 py-1" style="position:absolute !important; line-height: 1.5;top:0;right: 0;left: 0;padding-top: 0;height:20px;font-size: 14px;border-radius: 15px 0;color: #ffffffb3;background: rgb(42 54 134);">
                        {{pro.product_status_to_string}}
                      </v-btn>
                      <v-btn v-if="pro.product_status===3" class="myyell font-weight-bold px-1 py-1" style="position:absolute !important; line-height: 1.5;top:0;right: 0;left: 0;padding-top: 0;height:20px;font-size: 14px;border-radius: 15px 0;color: #ffffffb3;background: rgb(42 54 134);">
                        {{pro.product_status_to_string}}
                      </v-btn>
                      <v-btn v-if="pro.product_status===4" class="myred font-weight-bold px-1 py-1" style="position:absolute !important; line-height: 1.5;top:0;right: 0;left: 0;padding-top: 0;height:20px;font-size: 14px;border-radius: 15px 0;color: #ffffffb3;background: rgb(42 54 134);">
                        {{pro.product_status_to_string}}
                      </v-btn>
                      <v-btn v-if="pro.stamp_status"
                          :class="`font-weight-bold px-1 py-1 v-card--reveal `+pro.stamp_location===1?`top_left`:(pro.stamp_location===2?`bottom_right`:(pro.stamp_location===3?`bottom_left`:`top_right`))+` stampcolor${pro.stamp_color}`"
                          style="position:absolute !important;
                        line-height: 1.5;
                        padding-top: 0;
                        height:20px;
                        font-size: 14px;
                        border-radius: 15px 0;">{{pro.stamp_string}}</v-btn>
                    </v-img>
                    <v-card-text class="text--primary pa-1">
                      <v-btn class="font-weight-bold px-1 py-1" @click="Selectedproduct(pro.id)" style="position:absolute !important; line-height: 1.5;bottom:0;right: 0;left: 0;padding-top: 0;height:50px;font-size:14px;border-radius: 15px 0;color:#ffffffb3;background:rgb(42 54 134);">
                        {{pro.name_to_string}}<br>{{pro.product_final_total_to_number_format}}
                      </v-btn>
                    </v-card-text>
                  </v-card>
<!--                </v-hover>-->
              </div>
            </div>
          </v-card-text>
        </div>
      </div>
      <v-dialog :loading="AddProductLoadingDialog" v-model="AddProductDialog" max-width="100%" v-if="AddProductDialog" scrollable fullscreen>
        <v-card flat loader-height="10" tile>
          <v-toolbar class="justify-content-center white--text" color="primary darken-2" max-height="30" height="30">
            <v-toolbar-title v-text="$t('car_order')"/>
          </v-toolbar>
          <v-card-text>
            <div class="pt-1">
              <app-row dense class="ma-0 pa-0 pt-1">
                <app-col sm="12" md="12" dense class="ma-0 pa-0">
                  <v-tabs maxHeight="30" minHeight="30" height="30" style="box-shadow: #00000033 0 2px 4px, #00000024 0 4px 5px 0, #0000001f 0 1px 10px 0;">
                    <v-tab style="background-color: #2a3686 !important; border-radius: 5px; color:#ffffff;border-color: rgb(42 54 134) !important;" dense>
                      {{ parseAttribute('car') }}
                    </v-tab>
                  </v-tabs>
                </app-col>
              </app-row>
              <app-row dense class="ma-0 pa-0 pt-1">
                <app-col sm="12" md="4" dense class="ma-0 pa-0">
                  <app-row dense class="ma-0 pa-0">
                    <app-col sm="12" md="12" dense class="ma-0 pa-0">
                      <v-card-title sm="12" md="12" class="justify-center mhfslot2 ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="this.product.text+' / SKU '+this.product.product_sku"/>
                    </app-col>
                  </app-row>
                </app-col>
                <app-col sm="12" md="4" dense class="ma-0 pa-0">
                  <app-row dense class="ma-0 pa-0">
                    <app-col sm="6" md="4" dense class="ma-0 pa-0" style="background-color: #2A36865B !important; opacity: 80% !important;">
                      <v-card-title sm="12" md="12" class="justify-center mhfslot ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="parseAttribute('price')"/>
                    </app-col>
                    <app-col sm="6" md="8" dense class="ma-0 pa-0">
                      <v-card-title sm="12" md="12" class="justify-center mhfslot2 ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="product.price_to_number_format"/>
                    </app-col>
                  </app-row>
                </app-col>
                <app-col sm="12" md="4" dense class="ma-0 pa-0">
                  <app-row dense class="ma-0 pa-0">
                    <app-col sm="6" md="4" dense class="ma-0 pa-0" style="background-color: #2A36865B !important; opacity: 80% !important;">
                      <v-card-title sm="6" md="12" class="justify-center mhfslot ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="parseAttribute('brokerage_services')"/>
                    </app-col>
                    <app-col sm="6" md="8" dense class="ma-0 pa-0">
                      <v-card-title sm="6" md="12" class="justify-center mhfslot2 ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="product.brokerage_services_with_vat_to_number_format"/>
                    </app-col>
                  </app-row>
                </app-col>
                <app-col sm="12" md="4" dense class="ma-0 pa-0">
                  <app-row dense class="ma-0 pa-0">
                    <app-col sm="6" md="4" dense class="ma-0 pa-0" style="background-color: #2A36865B !important; opacity: 80% !important;">
                      <v-card-title sm="6" md="12"
                          class="justify-center mhfslot ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="parseAttribute('total')"/>
                    </app-col>
                    <app-col sm="6" md="8" dense class="ma-0 pa-0">
                      <v-card-title sm="6" md="12" class="justify-center mhfslot2 ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="product.product_final_total_to_number_format"/>
                    </app-col>
                  </app-row>
                </app-col>
                <app-col sm="12" md="4" dense class="ma-0 pa-0">
                  <app-row dense class="ma-0 pa-0">
                    <app-col sm="6" md="5" dense class="ma-0 pa-0" style="background-color: #2A36865B !important; opacity: 80% !important;">
                      <v-card-title sm="6" md="12"
                          class="justify-center mhfslot ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="parseAttribute('the_total')+' '+parseAttribute('down_payment')"/>
                    </app-col>
                    <app-col sm="6" md="7" dense class="ma-0 pa-0">
                      <v-card-title sm="6" md="12" class="justify-center mhfslot2 ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="product.product_down_payment_to_number_format"/>
                    </app-col>
                  </app-row>
                </app-col>
                <app-col sm="12" md="4" dense class="ma-0 pa-0">
                  <app-row dense class="ma-0 pa-0">
                    <app-col sm="6" md="5" dense class="ma-0 pa-0" style="background-color: #2A36865B !important; opacity: 80% !important;">
                      <v-card-title sm="6" md="12"
                          class="justify-center mhfslot ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="parseAttribute('the_total')+' '+parseAttribute('last_payment')"/>
                    </app-col>
                    <app-col sm="6" md="7" dense class="ma-0 pa-0">
                      <v-card-title sm="6" md="12" class="justify-center mhfslot2 ma-0 pa-0 ps-1 font-weight-normal text-decoration-none" v-text="product.product_final_rest_total_to_number_format"/>
                    </app-col>
                  </app-row>
                </app-col>
              </app-row>
              <app-row class="pa-0 ma-0 pt-1">
                <app-auto-select :items="user.verfied_user_identities" v-model="add_product.user_identity_id" :item-value="user.verfied_user_identities.id?user.verfied_user_identities.id:null" @change="Order_data_by_UserIdentity" rules="required" name="verfied_user_identity" ref="user_identity" id="user_identity" required sm="12" md="4"/>
                <app-text-input :readonly="true" rules="required" v-model="add_product.name_ar" name="name_ar" sm="12" md="4"/>
                <app-text-input :readonly="true" rules="required" v-model="add_product.name_en" name="name_en" sm="12" md="4"/>
                <app-text-input v-model="add_product.coupon_id" name="coupon_id" sm="12" md="4"/>
              </app-row>
            </div>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer></v-spacer>
            <app-btn color="primary" min-width="120" tooltip="order" @click="AddProductSubmit">{{ $t('order') }}</app-btn>
            <app-btn color="error" min-width="120" tooltip="close_window" @click="CloseAddProductDialog">{{ $t('close') }}</app-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="ContentShowDialog" v-if="ContentShowDialog" max-width="85%">
        <v-card style="box-shadow:none !important;">
          <v-card-text class="pa-0 ma-0 ">
            <div class="pa-0 ma-0 pt-1">
              <v-toolbar max-height="25" height="25" style=" background:transparent !important;position: fixed !important; top: 10px;">
                <v-btn icon class="pa-0 ma-0 md-3 sm-12" max-width="25" width="25" fab small max-height="25" height="25" min-width="25" @click="CloseContentShowDialog">
                  <v-icon style="color: white !important;">mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-carousel :height="mount_height2+`px`" :reverse="AppRtl" hide-delimiters hide-delimiter-background show-arrows>
                <template v-slot:next="{ on, attrs }">
                  <app-dt-btn max-height="30" min-height="27" min-width="27"
                      @click="clickNext(SelectedAttchment.ind)">
                    <v-icon v-if="AppRtl">mdi-chevron-left</v-icon>
                    <v-icon v-if="!AppRtl">mdi-chevron-right</v-icon>
                  </app-dt-btn>
                </template>
                <template v-slot:prev="{ on, attrs }">
                  <app-dt-btn max-height="30" min-height="27" min-width="27"
                      @click="clickPrev(SelectedAttchment.ind)">
                    <v-icon v-if="AppRtl">mdi-chevron-right</v-icon>
                    <v-icon v-if="!AppRtl">mdi-chevron-left</v-icon>
                  </app-dt-btn>
                </template>
                <v-carousel-item class="mx-0 mb-0 pb-0">
                  <app-row class="pa-0 ma-0" align="center" justify="center">
                    <v-img :max-height="mount_height2+`px`" :height="mount_height2+`px`" contain v-if="SelectedAttchment.file_type===1" :lazy-src="SelectedAttchment.url" :src="SelectedAttchment.url" alt="" />
                  </app-row>
                </v-carousel-item>
              </v-carousel>
            </div>
          </v-card-text>
          <v-divider/>
        </v-card>
      </v-dialog>
      <v-dialog :width="AppIsMobile?`100%`:`70%`" v-model="LoginDialog" v-if="LoginDialog">
        <app-row class="ma-0" width="100%" style="background: #f9f9f9;" align="center" justify="center">
          <v-col class="pa-0" style="background: #f9f9f9;" cols="12">
            <app-form :errors="errors" :submit="login" ref="form" v-slot="v">
              <v-card elevation="12" tile>
                <v-toolbar color="primary darken-2" dark flat>
                  <v-toolbar-title>{{ $t('login') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text md="6" sm="6" xs="6">
                  <app-text-input md="6" sm="12" xs="12"
                      :label="$t('attributes.login_id')"
                      name="login_id"
                      prepend-icon="mdi-account"
                      rules="required" v-if="Show_User_Password"
                      v-model="form.login_id"/>
                  <app-text-input md="6" sm="12" xs="12"
                      :label="$t('attributes.email')"
                      name="email"
                      rules="required|email" v-if="!Show_User_Password"
                      v-model="email"/>
                  <app-text-input v-on:keydown.enter="login"
                      :append-icon="passwordTypeIcon"
                      :label="$t('attributes.password')"
                      :type="passwordType"
                      @click:append="showPassword = !showPassword"
                      name="password" md="6" sm="6" xs="6"
                      prepend-icon="mdi-lock"
                      rules="required" v-if="Show_User_Password"
                      v-model="form.password"/>
                </v-card-text>
                <app-row width="100%" class="pa-0 ma-0">
                  <app-col md="2" sm="1" xs="12" class="pa-0 ma-0 text-center text-md-center text-sm-center"></app-col>
                  <app-col md="4" sm="11" xs="12" class="pa-0 ma-0 text-center text-md-center text-sm-center">
                    <v-card-text class="pa-0 ma-0 pointer" @click="ForgotPassword">
                      {{$t('attributes.forgot_password')}}
                    </v-card-text>
                  </app-col>
                  <app-col md="4" sm="12" xs="12" class="pa-0 ma-0 text-center text-md-center text-sm-center">
                    <v-card-text class="pa-0 ma-0 pointer" @click="ForgotUser">
                      {{$t('attributes.forgot_user')}}
                    </v-card-text>
                  </app-col>
                  <app-col md="2" sm="1" xs="12" class="pa-0 ma-0 text-center text-md-center text-sm-center"></app-col>
                </app-row>
                <v-card-actions>
                  <app-btn :loading="loading" v-if="Show_User_Password" @click="login">{{$t('login') }}</app-btn>
                  <app-btn :loading="loading" v-if="Forgot_Password&&!Show_User_Password" @click="ForgotPasswordClick">{{ $t('cancel') }}</app-btn>
                  <app-btn :loading="loading" v-if="Forgot_Password&&!Show_User_Password" @click="ForgotPasswordSubmit">{{ $t('attributes.forgot_password_send') }}</app-btn>
                  <app-btn :loading="loading" v-if="Forgot_User&&!Show_User_Password" @click="ForgotUserClick">{{ $t('cancel') }}</app-btn>
                  <app-btn :loading="loading" v-if="Forgot_User&&!Show_User_Password" @click="ForgotUserSubmit">{{ $t('attributes.forgot_user_send') }}</app-btn>
                  <v-spacer></v-spacer>
                  <app-btn :loading="loading" v-if="Show_User_Password" @click="SwitchModal">{{ $t('register') }}</app-btn>
                </v-card-actions>
              </v-card>
            </app-form>
          </v-col>
        </app-row>
      </v-dialog>
      <v-dialog :width="AppIsMobile?`100%`:`70%`" v-model="InfoDialog" v-if="InfoDialog">
        <app-row class="ma-0" width="100%" style="background: #f9f9f9;" align="center" justify="center">
          <v-col class="pa-0" style="background: #f9f9f9;" cols="12">
            <v-card elevation="12" tile>
                <v-toolbar color="primary darken-2" dark flat>
                  <v-toolbar-title>{{ $t('ExtraInfo') }}</v-toolbar-title>
                </v-toolbar>
                <app-row width="100%" class="pa-0 ma-0">
                  <v-col class="pa-3 text-start font-weight-bold" :class="!AppIsMobile?` pe-17`:` pe-3`" style="background: #f9f9f9;" cols="12">
                    الاسعار تشمل الآتي :<br>
                    1- قيمة السيارة.<br>
                    2- مصاريف التشييكات ان وجدت.<br>
                    3- النقل وتخليصها بكوريا وعمولتنا.<br>
                    4- الشحن من كوريا للسعودية.<br>
                    5- قيمة الجمرك والضريبة .<br>
                    6- جميع مصاريف الميناء المتبقيه وهي ( رسوم اذن التسليم من وكيل الشحن + رسوم التفريغ<br> + رسوم التخليص + رسوم هيئة المواصفات والمقاييس + رسوم النقل من الميناء الى المواصفات والعوده الى مقر البسامي بالدمام ) .<br>
                    —————————————<br>
                    &nbsp;&nbsp;• يتبقى على المشتري<br>
                    1&nbsp;&nbsp; - رسوم نقل البسامي اذا كان خارج الدمام ( مع خصم خاص على النقل ) .<br>
                    —————————————<br>
                    &nbsp;&nbsp;• اذا اراد المشتري الاستعمال الشخصي
                    يقوم بالتالي :<br>
                    1&nbsp;&nbsp;- سداد رسوم تسجيل مركبه جديده 400 ريال .<br>
                    2&nbsp;&nbsp;- فحص دوري 115 ريال .<br>
                    3&nbsp;&nbsp; - تأمين ( سعره يختلف من شخص لشخص ) .<br><br>

                    وعلى بركة الله<br>
                  </v-col>
                </app-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <app-btn :loading="loading" color="error" min-width="120" tooltip="close_window" @click="closeInfoDialog">{{ $t('close') }}</app-btn>
                </v-card-actions>
              </v-card>
          </v-col>
        </app-row>
      </v-dialog>
      <v-dialog scrollable :fullscreen="AppIsMobile" v-model="RegisterDialog" v-if="RegisterDialog">
        <app-row class="ma-0" width="100%" style="background: #f9f9f9;" align="center" justify="center">
          <v-col class="pa-0" style="background: #f9f9f9;" cols="12">
            <app-form :errors="errors" :submit="register" ref="registerform">
              <v-card elevation="12" tile class="pa-0">
                <v-toolbar class="justify-content-center" max-height="60" color="primary darken-2" dark flat>
                  <v-toolbar-title>{{ $t('register') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-0 ma-0">
                  <div class="pt-1">
                    <app-text-input md="6" sm="12"
                        v-model="formData.name_ar"
                        :label="$t('attributes.name_ar')"
                        name="name_ar"
                        rules="required|fullname"/>
                    <app-text-input md="6" sm="12"
                        v-model="formData.name_en"
                        :label="$t('attributes.name_en')"
                        name="name_en"
                        rules="fullname"/>
                    <app-text-input md="6" sm="12"
                        :label="$t('attributes.login_id')"
                        name="login_id"
                        prepend-icon="mdi-account"
                        rules="required"
                        v-model="formData.login_id"/>
                    <app-password-input md="6" sm="12"
                        :append-icon="passwordTypeIcon"
                        :label="$t('attributes.password')"
                        :type="passwordType"
                        @click:append="showPassword = !showPassword"
                        name="password" autocomplete="new-password"
                        prepend-icon="mdi-lock"
                        rules="required"
                        v-model="formData.password"/>
                    <app-password-input md="6" sm="12"
                        v-model="formData.password_confirmation"
                        name="password_confirmation"
                        rules="confirmed:password"/>
                    <app-text-input md="6" sm="12"
                        v-model="formData.email"
                        :label="$t('attributes.email')"
                        name="email"
                        rules="required"
                        prepend-icon="mdi-email"/>
                    <app-text-input md="6" sm="12"
                        v-model="formData.mobile"
                        :label="$t('attributes.mobile')"
                        name="mobile"
                        prepend-icon="mdi-cellphone"
                        v-on:keydown.enter="register"
                        rules="required|mobile"/>
                  </div>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <!--                <app-btn :loading="loading" type="submit">{{ $t('register') }}</app-btn>-->
                  <!--                <app-btn :loading="loading" @click="SwitchModal">{{ $t('login') }}</app-btn>-->
                  <!--                -->
                  <app-submit min-width="120" :loading="loading" tooltip="register">{{ $t('register') }}</app-submit>
                  <app-btn :loading="loading" min-width="120" tooltip="login" @click="SwitchModal">{{ $t('login') }}</app-btn>
                </v-card-actions>
              </v-card>
            </app-form>
          </v-col>
        </app-row>
      </v-dialog>
    </v-container>
  </div>
</template>
<style>
.v-application--is-ltr .pe-17 {
  padding-right: 16px !important;
}

.v-application--is-rtl .pe-17 {
  padding-left: 16px !important;
}
  .myCarousel .v-window__prev, .myCarousel .v-window__next {
    top: 0;
    position: fixed;
  }
  .v-slide-group__content {
    display: flex;
    flex: 1 0 auto;
    position: relative;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    white-space: nowrap;
    justify-content: center !important;
  }
  .v-dialog > .v-card > .v-card__text {
    padding: 0 10px 10px!important;
  }
  .nooponhover {
    opacity: 1 !important;
  }
  .noop {
    border: solid 1px #ff0000 !important;
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .6;
    position: absolute;
    width: 100%;
  }
  .v-breadcrumbs {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    flex: 0 1 auto;
    list-style-type: none;
    margin: 0;
    padding: 8px 12px;
  }
  .v-breadcrumbs__divider {
    color: rgba(0, 0, 0, 0.87) !important;
    font-weight: bolder !important;
  }
  .v-breadcrumbs li a {
    color: rgb(42 54 134);
    font-weight: 700;
    font-size: 16px;
  }
  .v-breadcrumbs li a:hover {
    color: rgba(42, 54, 13, 0.34);
    font-weight: 700;
    font-size: 16px;
  }
  .details-label {
    font-weight: 700;
    background: #bf0100;
    color: #fff;
  }
  .details-data {
    font-weight: 900;
  }
  .mhfslot{
    border: thin solid rgb(42 54 134) !important;
    line-height: 1.6rem !important;
    font-size: 1rem !important;
    font-weight: bolder !important;
    max-width: 100%;
    min-width: 0;
    width: 100%;
    color: rgba(0, 0, 0, 0.8);
  }
  .mhfslot2{
    border: thin solid rgb(42 54 134) !important;
    line-height: 1.6rem !important;
    font-size: 1rem !important;
    font-weight: bolder !important;
    text-align: center !important;
    max-width: 100%;
    min-width: 0;
    width: 100%;
    background-color: #f2f2f2 !important;
    color: rgba(0, 0, 0, 0.8);
  }
  .v-slide-group__prev i {
    color: black !important;
  }
  .v-slide-group__next i {
    color: black !important;
  }
  .theme--light.v-icon.v-icon.v-icon--disabled {
    color: rgba(75, 24, 24, 0.3) !important;
  }
  .top_left {
    position: absolute !important;
    line-height: 1.5;
    top: 45px;
    left: -5px;
    padding-top: 0px;
    height: 20px;
    font-size: 14px;
    transform: rotate(321deg);
    opacity: 0.8;
  }
  .top_right {
    position: absolute !important;
    line-height: 1.5;
    top: 45px !important;
    right: -5px !important;
    padding-top: 0px;
    height: 20px;
    font-size: 14px;
    transform: rotate(40deg);
    opacity: 0.8;
  }
  .bottom_right {
    position: absolute !important;
    line-height: 1.5;
    bottom: 70px;
    right: -5px;
    padding-top: 0px;
    height: 20px;
    font-size: 14px;
    transform: rotate(321deg);
    opacity: 0.8;
  }
  .bottom_left {
    position: absolute !important;
    line-height: 1.5;
    bottom: 70px;
    left: -5px;
    padding-top: 0px;
    height: 20px;
    font-size: 14px;
    transform: rotate(40deg);
    opacity: 0.8;
  }
  .stampcolor0{
    background-color: #2a3686 !important;
    border-color: #2a3686 !important;
    color: #ffffffb3 !important;
  }
  .stampcolor1{
    background-color: #bf0100 !important;
    border-color: #bf0100 !important;
    color: #ffffffb3 !important;
  }
  .stampcolor2{
    background-color: #009688 !important;
    border-color: #009688 !important;
    color: #ffffffb3 !important;
  }
  .stampcolor3{
    background-color: #004700 !important;
    border-color: #004700 !important;
    color: #ffffffb3 !important;
  }
  .stampcolor4{
    background-color: #2196f3 !important;
    border-color: #2196f3 !important;
    color: #ffffffb3 !important;
  }
  .stampcolor5{
    background-color: #4caf50 !important;
    border-color: #4caf50 !important;
    color: #ffffffb3 !important;
  }
  .stampcolor6{
    background-color: #607d8b !important;
    border-color: #607d8b !important;
    color: #ffffffb3 !important;
  }
  .stampcolor7{
    background-color: #9a97f5 !important;
    border-color: #9a97f5 !important;
    color: #000000b3 !important;
  }
  @media (max-width: 575.98px) {
    .v-breadcrumbs li a {
      font-weight: 400 !important;
      font-size: 14px !important;
    }
    .v-breadcrumbs li a:hover {
      font-weight: 400 !important;
      font-size: 14px !important;
    }
    .v-breadcrumbs__divider {
      color: rgba(0, 0, 0, 0.87) !important;
      font-weight: bolder !important;
    }
  }
  @media (max-width: 767px) {
    .v-breadcrumbs li a {
      font-weight: 400 !important;
      font-size: 14px !important;
    }
    .v-breadcrumbs li a:hover {
      font-weight: 400 !important;
      font-size: 14px !important;
    }
    .v-breadcrumbs__divider {
      color: rgba(0, 0, 0, 0.87) !important;
      font-weight: bolder !important;
    }
  }
</style>
<style scoped>
  .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
  }
</style>
<script>
export default {
  name: 'product',
  data() {
    return {
      stepNo: 0,
      showInfoDialog: !1,
      InfoDialog: null,
      LoginDialog: null,
      RegisterDialog: null,
      form: {
        login_id: null,
        password: null
      },
      formData: {},
      errors: {},
      loading: !1,
      showPassword: !1,
      slideValue: null,
      options: {
        closeOnEscape: true,
        closeOnSwipeUpOrDown: true,
        emulateTouchEvents: true,
        continuous: true,

      },
      index: null,
      row: undefined,
      product: [],
      cities: [],
      other_products: [],
      products:[],
      add_product:[],
      Viewed_Attachment:[],
      SelectedAttchment: {},
      subscribeLoading: !1,
      unsubscribeLoading: !1,
      AddProductLoadingDialog: !1,
      AddProductDialog: !1,
      ContentShowDialog: !1,
      mount_height: window.innerHeight*0.55,
      mount_height3: window.innerHeight*0.65,
      mount_height2: window.innerHeight*0.85,
      Show_User_Password:!0,
      Forgot_Password: !1,
      Forgot_User: !1,
      email: null,
    }
  },
  methods:{
    ForgotPasswordClick() {
      this.form.password = null;
      this.form.login_id = null;
      this.email = null;
      this.Forgot_Password = !1;
      this.Forgot_User = !1;
      this.Show_User_Password = !0;
    },
    ForgotUserClick() {
      this.form.password = null;
      this.form.login_id = null;
      this.email = null;
      this.Forgot_Password = !1;
      this.Forgot_User = !1;
      this.Show_User_Password = !0;
    },
    ForgotPassword() {
      this.form.password = null;
      this.form.login_id = null;
      this.email = null;
      this.Forgot_User = !1;
      this.Show_User_Password = !1;
      this.Forgot_Password = !0;
    },
    ForgotPasswordSubmit() {
      if(!this.email||this.email===''||this.email===null){return;}
      this.$axios.post(`forgot-password`, {email: this.email,})
          .then(data => {
            if (data.data && data.data.success) {
              this.alertSuccess(data.data.message);
              this.$nextTick(() => {
                this.Forgot_Password = !1;
                this.Forgot_User = !1;
                this.Show_User_Password = !0;
              });
            }
            else if(data.data && !data.data.success){
              this.alertError(data.data.message);
            }
          }).catch(({response}) => {
        const {data} = response || {};
        data && data.message && this.alertError(data.message) && data.errors;
        console.log(data.data);
      });
    },
    ForgotUser() {
      this.form.password = null;
      this.form.login_id = null;
      this.email = null;
      this.Forgot_Password = !1;
      this.Forgot_User = !this.Forgot_User;
      this.Show_User_Password = !1;
    },
    ForgotUserSubmit() {
      if(!this.email||this.email===''||this.email===null){return;}
      this.$axios.post(`forgot-user`, {email: this.email,})
          .then(data => {
            if (data.data && data.data.success) {
              this.alertSuccess(data.data.message);
              this.$nextTick(() => {
                this.email = null;
                this.Forgot_Password = !1;
                this.Forgot_User = !1;
                this.Show_User_Password = !0;
              });
            }
            else if(data.data && !data.data.success){
              this.alertError(data.data.message);
            }
          }).catch(({response}) => {
        const {data} = response || {};
        data && data.message && this.alertError(data.message) && data.errors;
        console.log(data.data);
      });
    },
    subscribe(){
      if(this.subscribeLoading) {return;}
      this.subscribeLoading = !0;
      this.$axios.get(`Panel/SubscribeProduct`, {params: {product_id: this.product.id}})
        .then(data => {
          if (data.data && data.data.success){
            this.get_product(this.product.id);
            this.subscribeLoading=!1;
          }
          else if(data.data && !data.data.success){
            this.alertError(data.data.message);
            this.subscribeLoading=!1;
          }
        })
        .catch(errordata => {
          console.log(errordata.response);
          this.subscribeLoading=!1;
        });
    },
    unsubscribe(){
      if(this.unsubscribeLoading) {return;}
      this.unsubscribeLoading = !0;
      this.$axios.get(`Panel/UnSubscribeProduct`, {params: {product_id: this.product.id}})
        .then(data => {
          if (data.data && data.data.success){
            this.get_product(this.product.id);
            this.unsubscribeLoading=!1;
          }
          else if(data.data && !data.data.success){
            this.alertError(data.data.message);
            this.unsubscribeLoading=!1;
          }
        })
        .catch(errordata => {
          console.log(errordata.response);
          this.unsubscribeLoading=!1;
        });
    },
    Check_Token_Process_Once(){
      if(this.isLogin) {
        let getprocess = Promise.resolve();
        getprocess = this.$axios.get(`check-token`)
         .then(({data}) => {
           if (data && data.data && data.success === true) {
             localStorage.setItem('perms', JSON.stringify(data.data.permissions));
             localStorage.setItem('backend_routes', JSON.stringify(data.data.routes));
             data = data.data
             this.user = data;
           }
         })
         .catch(errordata => {
           console.log(errordata.response);
         });
      }
    },
    login() {
      localStorage.removeItem('current_user');
      localStorage.removeItem('perms');
      localStorage.removeItem('backend_routes');
      localStorage.removeItem(this.$helpers.localstorageKey);
      this.loading = !0;
      return this.$api.methods.auth.login(this.form)
                 .then(({data}) => {
                   if (data && data.token) {
                     this.loginUser(data.token, data.data || {}, true)
                   }
                   else
                     this.loading = !1
                 })
                 .catch(({response}) => {
                   const {data} = response || {}
                   if (data) {
                     this.errors = data.errors || []
                     this.alertError(data.message)
                   }
                   this.loading = !1
                 })
    },
    register() {
      localStorage.removeItem('current_user');
      localStorage.removeItem('perms');
      localStorage.removeItem('backend_routes');
      localStorage.removeItem(this.localstorageKey);
      this.loading = !0;
      return this.$axios.post('register', this.formData)
                 .then(({data}) => {
                   if (data && data.token) {
                     this.alertSuccess(this.$t('messages.register_success'))
                     this.loginUser(data.token, data.data || {}, true)
                   }
                   else
                     this.loading = !1
                 })
                 .catch(({response}) => {
                   const {data} = response || {}
                   if (data) {
                     this.errors = data.errors || []
                     this.alertError(data.message)
                   }
                   this.loading = !1
                 })
    },
    LoginModalActivatior(){
      localStorage.removeItem('current_user');
      localStorage.removeItem('perms');
      localStorage.removeItem('backend_routes');
      localStorage.removeItem(this.localstorageKey);
      this.LoginDialog = !this.LoginDialog;
    },
    InfoModalActivatior(){
      this.InfoDialog = !0;
    },
    closeInfoDialog(){
      this.InfoDialog = !1;
    },
    RegisterModalActivatior(){
      localStorage.removeItem('current_user');
      localStorage.removeItem('perms');
      localStorage.removeItem('backend_routes');
      localStorage.removeItem(this.localstorageKey);
      this.RegisterDialog = !this.RegisterDialog;
    },
    SwitchModal(){
      localStorage.removeItem('current_user');
      localStorage.removeItem('perms');
      localStorage.removeItem('backend_routes');
      localStorage.removeItem(this.localstorageKey);
      this.RegisterDialog = !this.RegisterDialog;
      this.LoginDialog = !this.LoginDialog;
    },
    AddProductDialogActivator(){
      if(this.isLogin) {
        this.add_product = {};
        this.AddProductLoadingDialog = !1;
        this.AddProductDialog = !0;
      }
      else{
        this.LoginModalActivatior();
      }
    },
    CloseAddProductDialog(){
      this.add_product = {};
      this.AddProductLoadingDialog = !1;
      this.AddProductDialog = !1;
    },
    ContentShowDialogActivator(){
      this.ContentShowDialog = !0;
    },
    CloseContentShowDialog(){
      this.Viewed_Attachment = [];
      this.ContentShowDialog = !1;
    },
    AddProductSubmit(){
      if(this.AddProductLoadingDialog) {return;}
      if(!this.add_product.user_identity_id||!this.add_product.user_identity_id.id) {
        this.$refs.user_identity.$el.querySelector('#user_identity').focus();
        this.$refs.user_identity.$el.querySelector('#user_identity').select();
        return;
      }
      this.AddProductLoadingDialog=!0;
      this.add_product.product_id = this.product.id;
      this.add_product.user_id = this.user.id;
      this.add_product.user_identity_id = this.add_product.user_identity_id.id;
      this.$axios.post(`Panel/AddByUser`, this.add_product,{})
        .then(data => {
          if (data.data && data.data.success) {
            this.alertSuccess(data.data.message);
            this.$nextTick(() => {
              this.AddProductLoadingDialog=!1;
              this.add_product={};
              this.get_product(this.product.id);
              this.$router.push('/my-account/my-orders');
              this.AddProductDialog = !1;
            });
          }
          else if(data.data && !data.data.success){
            this.alertError(data.data.message);
            this.AddProductLoadingDialog=!1;
          }
        }).catch(errordata => {
        const {data} = errordata || {};
        data && data.message && this.alertError(data.message) && data.errors;
        this.AddProductLoadingDialog=!1;
      });
    },
    clickNext(n){
      n=n+1;
      this.onCardClick(n);
      this.showAttachment(this.product.attachments[n],n);
    },
    clickPrev(n){
      n=n-1;
      this.onCardClick(n);
      this.showAttachment(this.product.attachments[n],n);
    },
    onCardClick(n){
      this.slideValue = n;
    },
    showAttachment(i,b){
      i.ind = b;
      if(this.SelectedAttchment.file_type === 2){
        let stop_id = this.SelectedAttchment.id;
        let elm = document.getElementById('video'+stop_id);
        elm.pause();
        elm.currentTime = 0;
      }
      this.SelectedAttchment = i;
    },
    get_other_products() {
      this.other_products =[];
      if(this.product&&this.product.id) {
        let pars = {};
        pars.product_type = 1;
        pars.may_like = 1;
        pars.product_id = this.product.id;
        pars.product_model = this.product.product_model_id;
        pars.manufacturer = this.product.manufacturer_id;
        this.$axios.get(`Products`, {
          params: pars
        })
            .then(resdata => {
              this.other_products = resdata.data.data;
            })
            .catch(errordata => {
              console.log(errordata.response);
            });
      }
    },
    get_product(id=0) {
      if(id>0) {
        let pars = {};
        pars.id = id;
        this.$axios.get(``+this.Products_URL, {
          params: pars
        })
        .then(resdata => {
          this.product = resdata.data.data[0]?resdata.data.data[0]:[];
          this.SelectedAttchment = resdata.data.data[0].attachments[0]?resdata.data.data[0].attachments[0]:{};
          this.SelectedAttchment.ind = 1;
          this.slideValue = 0;
        })
        .catch(errordata => {
          console.log(errordata.response);
        })
        .finally(() => this.get_other_products());;
      }
    },
    Order_data_by_UserIdentity(sel) {
      this.add_product.name_ar = sel&&sel.name_ar?sel.name_ar:'';
      this.add_product.name_en = sel&&sel.name_en?sel.name_en:'';
    },
    breadcrums(){
      return [
        {text: this.$t('home'), disabled: false, href: 'home'},
        {text: this.$t('car_list'), disabled: false, href: 'products'},
        {text: this.product.text+' / SKU '+this.product.product_sku, disabled: true, href: 'product/' + this.product.id}
      ];
    },
    Selectedproduct(aid=0){
      if(aid>0) {
        this.get_product(aid);
        return this.$router.push('/product?id=' + this.product.id);
      }
    },
    onResize() {
      this.mount_height = window.innerHeight*0.55;
    },
  },
  mounted() {
    let aid = this.$route.query.id;
    if(aid&&aid>0) {
      this.get_product(aid);
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    if(this.isLogin) {
      this.Check_Token_Process_Once();
    }
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    visiblePages () {
      return this.other_products;
    },
    Products_URL () {
      return this.isLogin?'GetProducts':'Products';
    },
    subscribe_status: {
      get() {(this.product&&this.product.email_subs)?this.product.email_subs:false;},
    },
    passwordType() {
      return this.showPassword ? 'text' : 'password'
    },
    passwordTypeIcon() {
      return this.showPassword ? 'mdi-eye-off' : 'mdi-eye'
    },
    user: {
      get() {return this.$root.authUser || {};},
      set(v) {this.$root.authUser = v;},
    },
  },
}
</script>
